unit View.Codigo_bc_Piscofins.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCodigo_bc_PiscofinsEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcodigo_bc_piscofins_id: TLabel;
    edcodigo_bc_piscofins_id: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCodigo_bc_PiscofinsGet: TXDataWebClient;
    XDataClientCodigo_bc_PiscofinsDelete: TXDataWebClient;
    Codigo_bc_PiscofinsDataset: TXDataWebDataSet;
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id: TIntegerField;
    Codigo_bc_PiscofinsDatasetnome: TStringField;
    Codigo_bc_PiscofinsDatasetexcluido: TBooleanField;
    Codigo_bc_PiscofinsDatasetinclusao: TDateTimeField;
    Codigo_bc_PiscofinsDatasetalteracao: TDateTimeField;
    Codigo_bc_PiscofinsDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCodigo_bc_PiscofinsGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCodigo_bc_PiscofinsDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCodigo_bc_PiscofinsDeleteError(Error: TXDataClientError);
    procedure Codigo_bc_PiscofinsDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCodigo_bc_PiscofinsEdit: TFViewCodigo_bc_PiscofinsEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCodigo_bc_PiscofinsEdit }

procedure TFViewCodigo_bc_PiscofinsEdit.btSaveClick(Sender: TObject);
begin
  if Codigo_bc_PiscofinsDataset.State in dsEditModes then
  begin
        Codigo_bc_PiscofinsDataset.Post;
    Codigo_bc_PiscofinsDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.btDeleteClick(Sender: TObject);
begin
  if Codigo_bc_PiscofinsDataset.State in dsEditModes then
    Codigo_bc_PiscofinsDataset.Post;
  XDataClientCodigo_bc_PiscofinsDelete.Delete(Codigo_bc_PiscofinsDataset.EntitySetName,
    TJSObject(Codigo_bc_PiscofinsDataset.CurrentData));
end;


class function TFViewCodigo_bc_PiscofinsEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCodigo_bc_PiscofinsEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.InsertEntity;
begin
  Codigo_bc_PiscofinsDataset.Close;
  Codigo_bc_PiscofinsDataset.SetJsonData('{}');
  Codigo_bc_PiscofinsDataset.Open;
  Codigo_bc_PiscofinsDataset.Insert;
end;

class function TFViewCodigo_bc_PiscofinsEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCodigo_bc_PiscofinsEdit(AForm).FInserting := AInserting;
    TFViewCodigo_bc_PiscofinsEdit(AForm).FId := AId;
    TFViewCodigo_bc_PiscofinsEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCodigo_bc_PiscofinsEdit(AForm).InsertEntity
    else
      TFViewCodigo_bc_PiscofinsEdit(AForm).LoadEntity;
    TFViewCodigo_bc_PiscofinsEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCodigo_bc_PiscofinsEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCodigo_bc_PiscofinsEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    Codigo_bc_PiscofinsDataset.Connection.Model.DefaultSchema.FindEntityType(
      Codigo_bc_PiscofinsDataset.EntitySetName
    )
  );
  XDataClientCodigo_bc_PiscofinsGet.Get(Codigo_bc_PiscofinsDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCodigo_bc_PiscofinsEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.XDataClientCodigo_bc_PiscofinsGetLoad(Response: TXDataClientResponse);
begin
  Codigo_bc_PiscofinsDataset.Close;
  Codigo_bc_PiscofinsDataset.SetJsonData(Response.Result);
  Codigo_bc_PiscofinsDataset.Open;
  
  Codigo_bc_PiscofinsDataset.Edit;  
end;

procedure TFViewCodigo_bc_PiscofinsEdit.XDataClientCodigo_bc_PiscofinsDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCodigo_bc_PiscofinsEdit.XDataClientCodigo_bc_PiscofinsDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.Codigo_bc_PiscofinsDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCodigo_bc_PiscofinsEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.codigo_bc_piscofins.form.message');
  lbMessage := TLabel.Create('view.codigo_bc_piscofins.form.message.label');
  btCloseMessage := TButton.Create('view.codigo_bc_piscofins.form.message.button');
  btCancel := TButton.Create('view.codigo_bc_piscofins.form.btBack');
  btSave := TButton.Create('view.codigo_bc_piscofins.form.btSave');
  btDelete := TButton.Create('view.codigo_bc_piscofins.form.btDelete');
  lbcodigo_bc_piscofins_id := TLabel.Create('view.codigo_bc_piscofins.form.lbcodigo_bc_piscofins_id');
  edcodigo_bc_piscofins_id := TDBEdit.Create('view.codigo_bc_piscofins.form.edcodigo_bc_piscofins_id');
  lbnome := TLabel.Create('view.codigo_bc_piscofins.form.lbnome');
  ednome := TDBEdit.Create('view.codigo_bc_piscofins.form.ednome');
  lbexcluido := TLabel.Create('view.codigo_bc_piscofins.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.codigo_bc_piscofins.form.edexcluido');
  lbinclusao := TLabel.Create('view.codigo_bc_piscofins.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.codigo_bc_piscofins.form.edinclusao');
  lbalteracao := TLabel.Create('view.codigo_bc_piscofins.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.codigo_bc_piscofins.form.edalteracao');
  lbexclusao := TLabel.Create('view.codigo_bc_piscofins.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.codigo_bc_piscofins.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  Codigo_bc_PiscofinsDataset := TXDataWebDataSet.Create(Self);
  Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id := TIntegerField.Create(Self);
  Codigo_bc_PiscofinsDatasetnome := TStringField.Create(Self);
  Codigo_bc_PiscofinsDatasetexcluido := TBooleanField.Create(Self);
  Codigo_bc_PiscofinsDatasetinclusao := TDateTimeField.Create(Self);
  Codigo_bc_PiscofinsDatasetalteracao := TDateTimeField.Create(Self);
  Codigo_bc_PiscofinsDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCodigo_bc_PiscofinsGet := TXDataWebClient.Create(Self);
  XDataClientCodigo_bc_PiscofinsDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  edcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDataset.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetnome.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetexcluido.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetinclusao.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetalteracao.BeforeLoadDFMValues;
  Codigo_bc_PiscofinsDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCodigo_bc_PiscofinsGet.BeforeLoadDFMValues;
  XDataClientCodigo_bc_PiscofinsDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCodigo_bc_PiscofinsEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcodigo_bc_piscofins_id.SetParentComponent(Self);
    lbcodigo_bc_piscofins_id.Name := 'lbcodigo_bc_piscofins_id';
    lbcodigo_bc_piscofins_id.Left := 24;
    lbcodigo_bc_piscofins_id.Top := 192;
    lbcodigo_bc_piscofins_id.Width := 14;
    lbcodigo_bc_piscofins_id.Height := 13;
    lbcodigo_bc_piscofins_id.Caption := 'codigo_bc_piscofins_id:';
    lbcodigo_bc_piscofins_id.Transparent := True;
    edcodigo_bc_piscofins_id.SetParentComponent(Self);
    edcodigo_bc_piscofins_id.Name := 'edcodigo_bc_piscofins_id';
    edcodigo_bc_piscofins_id.Left := 221;
    edcodigo_bc_piscofins_id.Top := 189;
    edcodigo_bc_piscofins_id.Width := 200;
    edcodigo_bc_piscofins_id.Height := 21;
    edcodigo_bc_piscofins_id.Enabled := True;
    edcodigo_bc_piscofins_id.TabOrder := 6;
    edcodigo_bc_piscofins_id.Text := 'edcodigo_bc_piscofins_id';
    edcodigo_bc_piscofins_id.DataField := 'codigo_bc_piscofins_id';
    edcodigo_bc_piscofins_id.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := Codigo_bc_PiscofinsDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    Codigo_bc_PiscofinsDataset.SetParentComponent(Self);
    Codigo_bc_PiscofinsDataset.Name := 'Codigo_bc_PiscofinsDataset';
    Codigo_bc_PiscofinsDataset.AfterApplyUpdates := Codigo_bc_PiscofinsDatasetAfterApplyUpdates;
    Codigo_bc_PiscofinsDataset.EntitySetName := 'Codigo_bc_Piscofins';
    Codigo_bc_PiscofinsDataset.Connection := DMConnection.ApiConnection;
    Codigo_bc_PiscofinsDataset.Left := 176;
    Codigo_bc_PiscofinsDataset.Top := 8;
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.Name := 'Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id';
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.FieldName := 'codigo_bc_piscofins_id';
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.Required := True;
    Codigo_bc_PiscofinsDatasetnome.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetnome.Name := 'Codigo_bc_PiscofinsDatasetnome';
    Codigo_bc_PiscofinsDatasetnome.FieldName := 'nome';
    Codigo_bc_PiscofinsDatasetnome.Required := True;
    Codigo_bc_PiscofinsDatasetnome.Size := 255;
    Codigo_bc_PiscofinsDatasetexcluido.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetexcluido.Name := 'Codigo_bc_PiscofinsDatasetexcluido';
    Codigo_bc_PiscofinsDatasetexcluido.FieldName := 'excluido';
    Codigo_bc_PiscofinsDatasetexcluido.Required := False;
    Codigo_bc_PiscofinsDatasetinclusao.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetinclusao.Name := 'Codigo_bc_PiscofinsDatasetinclusao';
    Codigo_bc_PiscofinsDatasetinclusao.FieldName := 'inclusao';
    Codigo_bc_PiscofinsDatasetinclusao.Required := False;
    Codigo_bc_PiscofinsDatasetalteracao.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetalteracao.Name := 'Codigo_bc_PiscofinsDatasetalteracao';
    Codigo_bc_PiscofinsDatasetalteracao.FieldName := 'alteracao';
    Codigo_bc_PiscofinsDatasetalteracao.Required := False;
    Codigo_bc_PiscofinsDatasetexclusao.SetParentComponent(Codigo_bc_PiscofinsDataset);
    Codigo_bc_PiscofinsDatasetexclusao.Name := 'Codigo_bc_PiscofinsDatasetexclusao';
    Codigo_bc_PiscofinsDatasetexclusao.FieldName := 'exclusao';
    Codigo_bc_PiscofinsDatasetexclusao.Required := False;
    XDataClientCodigo_bc_PiscofinsGet.SetParentComponent(Self);
    XDataClientCodigo_bc_PiscofinsGet.Name := 'XDataClientCodigo_bc_PiscofinsGet';
    XDataClientCodigo_bc_PiscofinsGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCodigo_bc_PiscofinsGet, Self, 'OnLoad', 'XDataClientCodigo_bc_PiscofinsGetLoad');
    XDataClientCodigo_bc_PiscofinsGet.Left := 64;
    XDataClientCodigo_bc_PiscofinsGet.Top := 8;
    XDataClientCodigo_bc_PiscofinsDelete.SetParentComponent(Self);
    XDataClientCodigo_bc_PiscofinsDelete.Name := 'XDataClientCodigo_bc_PiscofinsDelete';
    XDataClientCodigo_bc_PiscofinsDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCodigo_bc_PiscofinsDelete, Self, 'OnLoad', 'XDataClientCodigo_bc_PiscofinsDeleteLoad');
    SetEvent(XDataClientCodigo_bc_PiscofinsDelete, Self, 'OnError', 'XDataClientCodigo_bc_PiscofinsDeleteError');
    XDataClientCodigo_bc_PiscofinsDelete.Left := 64;
    XDataClientCodigo_bc_PiscofinsDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcodigo_bc_piscofins_id.AfterLoadDFMValues;
    edcodigo_bc_piscofins_id.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDataset.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetcodigo_bc_piscofins_id.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetnome.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetexcluido.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetinclusao.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetalteracao.AfterLoadDFMValues;
    Codigo_bc_PiscofinsDatasetexclusao.AfterLoadDFMValues;
    XDataClientCodigo_bc_PiscofinsGet.AfterLoadDFMValues;
    XDataClientCodigo_bc_PiscofinsDelete.AfterLoadDFMValues;
  end;
end;

end.
